import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  newsItem: {
    textDecoration: 'none'
  }
})
